import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import tippy from 'tippy.js'

class DistanceWarning extends React.Component {
  componentDidMount = _ => {
    tippy(`.${this.props.classes.warningWrapper}`, {
      duration: 0,
      theme: 'topbar',
      placement: 'top',
      distance: 5
    })
  }

  render = _ =>
    <span
      title={`Copper Ethernet cables should not exceed ${this.props.isImperial ? '328 feet' : '100 meters'}`}
      className={this.props.classes.warningWrapper}
    >
      <FontAwesomeIcon icon='exclamation-triangle' />
    </span>
}

export default injectSheet(style)(DistanceWarning)



// WEBPACK FOOTER //
// ./src/components/Wire/DistanceWarning/index.js